<template>
    <div :class="isMobile?'pc' : 'homes'" id="topbar">
        <el-container style="height: 100%;">
            <el-header style="background-color: rgb(62,69,64);position: relative;">
                <div style="width: 240px;height: 56px;position: relative;">
                    <div style="color: #fff;position: absolute;top: 50%;left: 40px;transform: translateY(-50%);font-size: 20px;font-weight: 600;">期刊后台管理系统</div>
                </div>

                <div  style="text-align: right; font-size: 12px;position: absolute;top: 20px;right: 20px;z-index: 99;background-color:none;font-size:14px;font-weight:bold;cursor: pointer;">
                
                    <el-dropdown trigger="click">
                            <span style="font-weight: bold;color: #fff;">超级管理员</span>
                            <el-dropdown-menu slot="dropdown">
                                <div @click="UserInfo">
                                    <el-dropdown-item>修改密码</el-dropdown-item>
                                </div>
                                <div @click="LogOut">
                                    <el-dropdown-item>退出登录</el-dropdown-item>
                                </div>
                            </el-dropdown-menu>
                        </el-dropdown>
                </div>
            </el-header>
            <el-container>
                <el-aside :width="isCollapse?'':'240px'" style="background-color: rgb(62,69,64);transition: all 0.2s;overflow-x: hidden;margin-bottom:0px;">
                    <div style="box-sizing: border-box;width: 34px;height: 40px;margin-top:10px;cursor: pointer;margin: 0 auto;" @click="toggleClick">
                        <svg
                        :class="active?'is-actives':''"
                        class="hamburger"
                        viewBox="0 0 1024 1024"
                        xmlns="http://www.w3.org/2000/svg"
                        width="32"
                        height="32"
                        >
                        <path d="M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 0 0 0-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0 0 14.4 7z" />
                        </svg>
                    </div>
                    <!-- <div style="width: 100%;height: 56px;position: relative;">
                        <div style="color: #fff;position: absolute;top: 50%;left: 90px;transform: translateY(-50%);">厨艺分享</div>
                    </div> -->
                    <el-menu 
                    :default-active="path"
                    :collapse="isCollapse"
                    @select="handleSelect"
                    route
                    style="background-color: rgba(64,158,255,0);border:none;text-align: left;"
                    :collapse-transition="false"
                    >
                        <el-menu-item index="/index">
                            <i class="el-icon-s-grid" style="color:#fff"></i>
                            <span style="font-size: 16px;color:#fff" slot="title">首页</span>
                        </el-menu-item>
                        <el-menu-item index="/MeetingManagement">
                            <i class="el-icon-s-promotion" style="color:#fff"></i>
                            <span style="font-size: 16px;color:#fff" slot="title">会议管理</span>
                        </el-menu-item>
                        <el-menu-item index="/PeriodicalManagement">
                            <i class="el-icon-info" style="color:#fff"></i>
                            <span style="font-size: 16px;color:#fff" slot="title">期刊管理</span>
                        </el-menu-item>
                        <el-menu-item index="/CallforPapers">
                            <i class="el-icon-s-management" style="color:#fff"></i>
                            <span style="font-size: 16px;color:#fff" slot="title">专刊管理</span>
                        </el-menu-item>
                        <el-menu-item index="/NoticeAnnouncement">
                            <i class="el-icon-service" style="color:#fff"></i>
                            <span style="font-size: 16px;color:#fff" slot="title">通知公告</span>
                        </el-menu-item>
                        <el-menu-item index="/PostManagement">
                            <i class="el-icon-s-flag" style="color:#fff"></i>
                            <span style="font-size: 16px;color:#fff" slot="title">岗位管理</span>
                        </el-menu-item>
                        <el-menu-item index="/SystemManagement/Discipline">
                            <i class="el-icon-s-tools" style="color:#fff"></i>
                            <span style="font-size: 16px;color:#fff" slot="title">学科管理</span>
                        </el-menu-item>
                        <el-menu-item index="/ProblemFeedback">
                            <i class="el-icon-s-comment" style="color:#fff"></i>
                            <span style="font-size: 16px;color:#fff" slot="title">问题反馈</span>
                        </el-menu-item>
                        <el-menu-item index="/TimedTask">
                            <i class="el-icon-timer" style="color:#fff"></i>
                            <span style="font-size: 16px;color:#fff" slot="title">定时任务</span>
                        </el-menu-item>
                        <!-- <el-menu-item index="/SystemManagement/classification">
                            <i class="el-icon-s-tools" style="color:#fff"></i>
                            <span style="font-size: 16px;color:#fff" slot="title">分类管理</span>
                        </el-menu-item> -->
                    </el-menu>
                </el-aside>
                <el-main style="padding:0;">
                    <app-main class="Main" />
                </el-main>
            </el-container>
        </el-container>

        <el-dialog
            title="密码修改"
            :visible.sync="UpdataPassword"
            width="30%"
        >
            <el-form
                :model="PassWordParam"
                :rules="rules"
                ref="PassWordParam"
                label-width="140px"
                class="demo-ruleForm"
            >
                <el-form-item label="旧密码" prop="old_password">
                    <el-input
                    type="password"
                        placeholder="请输入旧密码"
                        v-model="PassWordParam.old_password"
                    ></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="new_password">
                    <el-input
                    type="password"
                        placeholder="请输入新密码"
                        v-model="PassWordParam.new_password"
                    ></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="PassWordCancel">取 消</el-button>
                <el-button type="primary" @click="PassWordConfirm">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { AppMain } from "../components";
import { MessageBox } from 'element-ui'
import { removeToken } from '../utils/auth.js'

import {change_password} from '../api/login.js';

export default {
    name: "Layout",
    components: {
        AppMain,
    },
    data(){
        return{
            isMobile:true,
            screenWidth: null,//屏幕宽度
            UpdataPassword:false,
            userNickname:'超级管理员',
            path : '',
            active : false,
            isCollapse:false,
            loading: null, //加载动画
            role:'2',
            staffState:false,//员工弹窗状态
            staffForm:{
                
            },//员工表单
            rules:{//员工验证
                old_password: [
                    {
                        required: true,
                        message: "请输入旧密码",
                        trigger: "blur",
                    },
                ],
                new_password: [
                    {
                        required: true,
                        message: "请输入新密码",
                        trigger: "blur",
                    },
                ],
            },
            PassWordParam:{
                old_password:'',
                new_password:''
            }
        }
    },
    created() {
        this.path= this.$router.history.current.fullPath
    },
    mounted() {
        let that = this
        window.addEventListener('resize',function(){
            that.screenWidth = document.body.offsetWidth;
        })
        if (this.isMobileFun()) {
            this.isMobile = false
        } else {
            this.isMobile = true
        }
    },
    watch:{
        $route(to){
            this.path = to.path
        },
        screenWidth:function(val){
            if (this.isMobileFun()) {
                this.isMobile = false
            } else {
                this.isMobile = true
            }
        }
    },
    methods:{
        isMobileFun() {
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            return flag;
        },
        // 个人用户信息
        UserInfo(){
            this.UpdataPassword = true
            this.PassWordParam = {}
        },
        PassWordCancel(){
            this.UpdataPassword = false
            this.PassWordParam = {}
        },
        PassWordConfirm(){
            
            this.$refs['PassWordParam'].validate((valid) => {
                if (valid) {
                    change_password(this.PassWordParam).then(res=>{
                        if(res.code == 200){
                            this.PassWordCancel()
                            setTimeout(() => {
                                removeToken('Admin-Token')
                                location.href = '/';
                            }, 1000);
                        }
                    })
                } else {
                    return false;
                }
            });
        },
        // 退出登录
        LogOut(){
            MessageBox.confirm('您确定退出登录？', '系统提示', {
            confirmButtonText: '退出登录',
            cancelButtonText: '取消',
            type: 'warning'
        }
            ).then(() => {
                removeToken('Admin-Token')
                location.href = '/';
            })
        },
        // 切换左部导航栏状态
        toggleClick(){
            this.active = !this.active
            this.isCollapse = !this.isCollapse
        },
        handleSelect(key){
            if(this.path != key){
                this.path = key
                this.$router.push(key)
            }else{
                return
            }
            
        },
    }
};
</script>

<style lang="scss" >
.homes{
    width: 1920px;
    min-height: 960px;
    height: 100%;
    margin: 0 auto;
}
.pc{
    width: 100%;
    height: 100vh;
    margin: 0 auto;
}
.el-menu-item.is-active{
        color: #fff !important;
        background-color: #409EFF !important;
    }
    .el-menu-item.is-active:hover{
        color: #fff;
        background-color: #409EFF !important;
        font-weight: bold;
    }
    .el-submenu .el-menu{
        background-color: rgba(64,158,255,0);
        overflow: hidden;
    }
    .el-submenu__title:hover{
        color: #fff;
        background-color: #409EFF !important;
    }
    .el-menu-item:focus, .el-menu-item:hover{
        color: #fff;
        background-color: #409EFF !important;
    }
    /* .el-menu-item.is-active */
    /* .el-submenu .el-menu-item{
        color: #fff;
        font-weight: bold;
    } */
    .is-actives {
        transform: rotate(180deg);
    }
    .el-submenu > .el-submenu__title{
        color: #fff;
    }
    .el-submenu > .el-submenu__title i{
        color: #fff;
    }
    
</style>